<template>
  <MainLayout>
    <div class="settings-container">
      <h1>Settings</h1>
      
      <div class="settings-content">
        <p class="placeholder-text">Settings page is under construction.</p>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '../components/MainLayout.vue'

export default {
  name: 'Settings',
  components: {
    MainLayout
  }
}
</script>

<style scoped>
.settings-container {
  padding: 16px;
}

h1 {
  margin-bottom: 20px;
  text-align: center;
}

.settings-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.placeholder-text {
  color: var(--tg-theme-hint-color);
  font-size: 16px;
}
</style> 